import { render, staticRenderFns } from "./FilesSidebarChatView.vue?vue&type=template&id=8090d800&scoped=true"
import script from "./FilesSidebarChatView.vue?vue&type=script&lang=js"
export * from "./FilesSidebarChatView.vue?vue&type=script&lang=js"
import style0 from "./FilesSidebarChatView.vue?vue&type=style&index=0&id=8090d800&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8090d800",
  null
  
)

export default component.exports